

/**
 * enum for result returned from server
 */

enum PageStatus  {
    None= 0,
    Success = 1,
    Fail= 2,
    Warning = 3,
    Waiting = 4,
    FirstLoad= 5
}

/**
 * enum for page action send to server
 */
enum PageAction {
    None= 0,
    Save= 1,
    Reset= 2
}
/**
 * enum for page type: Product or List of products
 */
enum PageName {
    List= 0,
    Product= 1
}

/**
 * enum for user build preset or custom
 */
enum BuildUserType  {
    None= 0,
    Preset= 1,
    Custom= 2
}

/**
 * enum for render SblMain Mode
 */
enum RenderSblMainMode  {
    EmptyCategories= 0,
    FirstCategoryOpened= 1,
    All= 2
}

/**
 * enum for popup type
 */
enum PopupType  {
    Array= 0,
    Message= 1,
    HTML= 2
}
/**
 * enum for popup type
 */
enum ResultLocation  {
    notShow= 0,
    Top= 1,
    Bottom= 2,
    TopBottom= 3,
    Custom= 4
}

/**
 * enum for cable logic
 */
enum CableLogic  {
    None= 0,
    Static= 1,
    productNeedCable= 2
}

/**
 * enum for cable logic
 */
enum CategoryIdExclusion  {
    Software= 1,
    NetworkSwitches= 5,
    StageBoxes= 8
}

/**
 * enum for categories ids
 */
enum CategoriesIds  {
    HostComputer= 2,
    LocalIO= 9,
    NetworkSwitches= 5,
    RacksAndAccessories=4,
    ScreensAndControllers=6,
    Software= 1,
    SoundGridServers= 3,
    StageBoxes= 8
}
/**
 * enum for products ids
 */
enum ProductsIds  {
    Cable =40
}
export const LocalEnums = {
    ProductsIds,
    PageStatus,
    PageAction,
    PageName,
    BuildUserType,
    RenderSblMainMode,
    PopupType,
    ResultLocation,
    CableLogic,
    CategoryIdExclusion,
    CategoriesIds
}
//https://wavesaudio.atlassian.net/browse/DSWEB-1021
export const MaxNumberOfChannelInputs = 64;


